import React, { useEffect, useState } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { Loader } from 'core-components/library/loader'
import { safeImageUrl } from 'search/classes/helpers/safeImageUrl'
import { companySearchStoreService } from 'search/classes/services/CompanySearchStoreService'
import styles from 'search/components/widgets/public/CompanySearch.module.scss'
import settings from 'src/config/settings'
import { HttpCancel } from 'src/core/classes/http'

interface IProps {
  widgetParams: IObjectAny
  pid?: string
}

export const CompanySearch = (props: IProps) => {
  const [searchString, setSearchString] = useState('')
  const [searchResult, setSearchResult] = useState([])
  const [companyInfo, setCompanyInfo] = useState<IObjectAny | undefined>(undefined)
  const [searchStory, setSearchStory] = useState<IForm[] | undefined>(undefined)
  const [loadCompanies, setLoadCompanies] = useState(false)
  const [loadInfo, setLoadInfo] = useState(false)
  const pid = props.pid || (props.widgetParams && props.widgetParams.PartnerProId)
  useEffect(() => {
    if (!document.getElementById('googleApi')) {
      const script = document.createElement('script')
      script.id = 'googleApi'
      script.src = `https://maps.googleapis.com/maps/api/js?key=${settings.googleApiKey}&libraries=places`
      script.type = 'text/javascript'
      script.async = true
      document.body.appendChild(script)
    }
    setLoadCompanies(true)
    const cancelObject = new HttpCancel()
    companySearchStoreService.init(pid || 'none', cancelObject).then((searchResult) => {
      if (searchResult.total) {
        setSearchStory(searchResult['items'])
      }
      setLoadCompanies(false)
    })
  }, [pid])

  const searchCompanies = async () => {
    if (!searchString.length) {
      return
    }
    setLoadCompanies(true)
    const cancelObject = new HttpCancel()
    const searchResult = await companySearchStoreService.getCompanies(
      searchString,
      props.pid || (props.widgetParams || {})['PartnerProId'] || 'none',
      cancelObject
    )
    if (searchResult.total) {
      setSearchResult(JSON.parse(searchResult['items'][0]['Rows'] || ''))
    } else {
      setSearchResult([])
    }
    setLoadCompanies(false)
  }

  const searchCompanyInfo = async (id: string) => {
    setLoadInfo(true)
    const cancelObject = new HttpCancel()
    const searchResult = await companySearchStoreService.getCompanyInfo(
      id,
      props.pid || (props.widgetParams || {})['PartnerProId'] || 'none',
      cancelObject
    )
    if (searchResult.total) {
      setCompanyInfo(JSON.parse(searchResult['items'][0]['Rows'] || ''))
    }
    setLoadInfo(false)
  }

  const renderCompanyInfo = () => {
    if (loadInfo) {
      return <Loader dimension={{ height: 300 }} />
    }
    if (companyInfo) {
      return (
        <>
          <div key={companyInfo['id']} className={styles.companyName}>
            <b>{companyInfo['name']}</b>
          </div>
          <div style={{ marginBottom: 20 }}>
            # {(companyInfo['types'] || []).map((item: any) => `${item},  `)}
          </div>
          <div>
            <p style={{ lineHeight: '23px' }}>
              <b>Address:</b> {companyInfo['formatted_address']} <br />
              <b>Phone:</b> {companyInfo['formatted_phone_number']} <br />
              <b>International Phone:</b> {companyInfo['international_phone_number']} <br />
              <b>Website:</b> {companyInfo['website']} <br />
              <b>User rating:</b> {companyInfo['user_ratings_total'] || '-'}
            </p>
          </div>
          {(companyInfo['reviews'] || []).length ? (
            <div style={{ marginBottom: 10 }}>
              <b>Reviews</b>
            </div>
          ) : null}
          {(companyInfo['reviews'] || []).map((item: any) => {
            const photoUrl = safeImageUrl(item['profile_photo_url'])
            return (
              <div key={item['time']}>
                <div style={{ width: '95%', marginBottom: 20 }}>
                  {photoUrl ? (
                    <img
                      src={photoUrl}
                      alt={''}
                      referrerPolicy={'no-referrer'}
                      className={styles.companyIcon}
                    />
                  ) : null}
                  <p>
                    <b>{item['author_name']}</b> <br />
                    {item['relative_time_description']}
                  </p>
                  <div style={{ marginTop: -10 }}>{item['text']}</div>
                </div>
              </div>
            )
          })}
        </>
      )
    }
    return null
  }

  const renderCompanies = () => {
    if (loadCompanies) {
      return <Loader dimension={{ height: 300 }} />
    }
    if (searchResult) {
      return searchResult.map((item) => {
        const iconUrl = safeImageUrl(item['icon'])
        return (
          <div
            key={item['place_id']}
            onClick={() => searchCompanyInfo(item['place_id'])}
            style={{ width: '100%', cursor: 'pointer' }}
          >
            {iconUrl ? (
              <img
                src={iconUrl}
                alt={''}
                referrerPolicy={'no-referrer'}
                className={styles.companiesIcon}
              />
            ) : null}
            <p style={{ marginBottom: 20, lineHeight: '23px' }}>
              {item['name']}
              <br />
              {item['formatted_address']}
              <br />
              {item['place_id']}
            </p>
          </div>
        )
      })
    }
    return null
  }

  const renderSearchStory = () => {
    if (loadCompanies) {
      return <Loader dimension={{ height: 300 }} />
    }
    if (searchStory) {
      return (
        <>
          <div style={{ marginBottom: 20 }}>Search History</div>
          {searchStory.map((item: any) => (
            <div
              key={item['EntryId']}
              onClick={() => searchCompanyInfo(item['PlaceId'])}
              style={{ width: '100%', cursor: 'pointer', marginBottom: 10 }}
            >
              <span style={{ verticalAlign: 'top' }}>
                <i className={'kbase kbase-search'} style={{ marginRight: 5 }} />
                {JSON.parse(item['Rows'])['name']}
              </span>
            </div>
          ))}
        </>
      )
    }
    return (
      <>
        <div style={{ marginBottom: 20 }}>Search History</div>
        <span>Not found</span>
      </>
    )
  }

  return (
    <>
      <div style={{ width: '100%', marginBottom: 20 }}>
        <span>Search Company: </span>
        <Input
          classes={{ root: styles.input }}
          placeholder={'Search…'}
          value={searchString}
          onChange={(val) => setSearchString(val)}
        />
        <Button onClick={searchCompanies}>Search</Button>
      </div>
      <div className={styles.halfBlock}>
        {searchResult.length ? renderCompanies() : renderSearchStory()}
      </div>
      <div className={styles.halfBlock}>{renderCompanyInfo()}</div>
    </>
  )
}
